export default "__VITE_ASSET__BM2TTISX__"